import { JOB_SEARCH_EVENTS } from '../../constants/events';


export const updateJobSearchList = (context = {}) => ({
	type: JOB_SEARCH_EVENTS.UPDATE_JOB_SEARCH_LIST,
	payload: context
});

export const emptyJobSearchList = (context = {}) => ({
	type: JOB_SEARCH_EVENTS.EMPTY_JOB_SEARCH_LIST,
	payload: context
});


export const updateDfpOptions = (context = {}) => ({
	type: JOB_SEARCH_EVENTS.UPDATE_DFP_OPTIONS,
	payload: context
});

export const toggleJobListDisplay = (show) => ({
	type: JOB_SEARCH_EVENTS.TOGGLE_JOB_LIST_DISPLAY,
	payload: {
		hideJobs: !show
	}
});

export const updateJobSearchReducer = (context={}) => ({
  type: JOB_SEARCH_EVENTS.UPDATE_JOB_SEARCH_REDUCER,
  payload: context
});



// WEBPACK FOOTER //
// ../q-jobs/src/actions/JobSearchActions/index.js